/**
 * TypeScript definitions for keyboard event code values that are consistent
 * across major browsers (Firefox and Chrome) on different platforms.
 */
export const enum KeyboardEventCode {
    // Modifiers
    AltLeft = 'AltLeft',
    AltRight = 'AltRight',
    ControlLeft = 'ControlLeft',
    ControlRight = 'ControlRight',
    ShiftLeft = 'ShiftLeft',
    ShiftRight = 'ShiftRight',
    MetaLeft = 'MetaLeft',
    MetaRight = 'MetaRight',

    // Standard letters
    KeyA = 'KeyA',
    KeyB = 'KeyB',
    KeyC = 'KeyC',
    KeyD = 'KeyD',
    KeyE = 'KeyE',
    KeyF = 'KeyF',
    KeyG = 'KeyG',
    KeyH = 'KeyH',
    KeyI = 'KeyI',
    KeyJ = 'KeyJ',
    KeyK = 'KeyK',
    KeyL = 'KeyL',
    KeyM = 'KeyM',
    KeyN = 'KeyN',
    KeyO = 'KeyO',
    KeyP = 'KeyP',
    KeyQ = 'KeyQ',
    KeyR = 'KeyR',
    KeyS = 'KeyS',
    KeyT = 'KeyT',
    KeyU = 'KeyU',
    KeyV = 'KeyV',
    KeyW = 'KeyW',
    KeyX = 'KeyX',
    KeyY = 'KeyY',
    KeyZ = 'KeyZ',

    // Digits
    Digit0 = 'Digit0',
    Digit1 = 'Digit1',
    Digit2 = 'Digit2',
    Digit3 = 'Digit3',
    Digit4 = 'Digit4',
    Digit5 = 'Digit5',
    Digit6 = 'Digit6',
    Digit7 = 'Digit7',
    Digit8 = 'Digit8',
    Digit9 = 'Digit9',

    // Function keys
    F1 = 'F1',
    F2 = 'F2',
    F3 = 'F3',
    F4 = 'F4',
    F5 = 'F5',
    F6 = 'F6',
    F7 = 'F7',
    F8 = 'F8',
    F9 = 'F9',
    F10 = 'F10',
    F11 = 'F11',
    F12 = 'F12',
    F13 = 'F13',
    F14 = 'F14',
    F15 = 'F15',
    F16 = 'F16',
    F17 = 'F17',
    F18 = 'F18',
    F19 = 'F19',
    F20 = 'F20',
    F21 = 'F21',
    F22 = 'F22',
    F23 = 'F23',
    F24 = 'F24',

    // Numpad
    Numpad0 = 'Numpad0',
    Numpad1 = 'Numpad1',
    Numpad2 = 'Numpad2',
    Numpad3 = 'Numpad3',
    Numpad4 = 'Numpad4',
    Numpad5 = 'Numpad5',
    Numpad6 = 'Numpad6',
    Numpad7 = 'Numpad7',
    Numpad8 = 'Numpad8',
    Numpad9 = 'Numpad9',
    NumpadAdd = 'NumpadAdd',
    NumpadComma = 'NumpadComma',
    NumpadDecimal = 'NumpadDecimal',
    NumpadDivide = 'NumpadDivide',
    NumpadEnter = 'NumpadEnter',
    NumpadEqual = 'NumpadEqual',
    NumpadMultiply = 'NumpadMultiply',
    NumpadSubtract = 'NumpadSubtract',

    // Navigation
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    End = 'End',
    Home = 'Home',
    PageDown = 'PageDown',
    PageUp = 'PageUp',

    // UI keys
    Escape = 'Escape',
    Tab = 'Tab',
    CapsLock = 'CapsLock',
    Space = 'Space',
    Backspace = 'Backspace',
    Enter = 'Enter',
    Delete = 'Delete',
    Insert = 'Insert',
    ContextMenu = 'ContextMenu',
    PrintScreen = 'PrintScreen',
    ScrollLock = 'ScrollLock',
    Pause = 'Pause',
    NumLock = 'NumLock',

    // Punctuation
    Backquote = 'Backquote',
    BracketLeft = 'BracketLeft',
    BracketRight = 'BracketRight',
    Comma = 'Comma',
    Equal = 'Equal',
    Minus = 'Minus',
    Period = 'Period',
    Quote = 'Quote',
    Semicolon = 'Semicolon',
    Slash = 'Slash',
    Backslash = 'Backslash',

    // International keys
    IntlBackslash = 'IntlBackslash',
    IntlRo = 'IntlRo',
    IntlYen = 'IntlYen',

    // IME keys
    Convert = 'Convert',
    KanaMode = 'KanaMode',
    Lang1 = 'Lang1',
    Lang2 = 'Lang2',
    NonConvert = 'NonConvert',

    // Media keys
    MediaPlayPause = 'MediaPlayPause',
    MediaStop = 'MediaStop',
    MediaTrackNext = 'MediaTrackNext',
    MediaTrackPrevious = 'MediaTrackPrevious',

    // Browser keys
    BrowserBack = 'BrowserBack',
    BrowserFavorites = 'BrowserFavorites',
    BrowserForward = 'BrowserForward',
    BrowserHome = 'BrowserHome',
    BrowserRefresh = 'BrowserRefresh',
    BrowserSearch = 'BrowserSearch',
    BrowserStop = 'BrowserStop',

    // Misc
    LaunchApp1 = 'LaunchApp1',
    LaunchApp2 = 'LaunchApp2',
    LaunchMail = 'LaunchMail',
    MediaSelect = 'MediaSelect',
    AudioVolumeMute = 'AudioVolumeMute',
    AudioVolumeDown = 'AudioVolumeDown',
    AudioVolumeUp = 'AudioVolumeUp',
    Power = 'Power',
    Eject = 'Eject',
    Help = 'Help',
    Again = 'Again',
    Copy = 'Copy',
    Cut = 'Cut',
    Find = 'Find',
    Open = 'Open',
    Paste = 'Paste',
    Props = 'Props',
    Select = 'Select',
    Undo = 'Undo',
    WakeUp = 'WakeUp',
}
